import { useState, useEffect } from 'react';
import { Search, CheckCircle, XCircle, Phone, MapPin, Building2, Clock, School, UserCircle } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { supabase, getSupabaseUrl } from '../../supabase/client';
import { formatDateTime } from '../../utils/timeUtils';

const regionData: Record<string, string[]> = {
  '北京': ['北京市'], '上海': ['上海市'], '天津': ['天津市'], '重庆': ['重庆市'],
  '河北': ['石家庄', '唐山', '秦皇岛', '邯郸', '邢台', '保定', '张家口', '承德', '沧州', '廊坊', '衡水'],
  '山西': ['太原', '大同', '阳泉', '长治', '晋城', '朔州', '晋中', '运城', '忻州', '临汾', '吕梁'],
  '辽宁': ['沈阳', '大连', '鞍山', '抚顺', '本溪', '丹东', '锦州', '营口', '阜新', '辽阳', '盘锦', '铁岭', '朝阳', '葫芦岛'],
  '吉林': ['长春', '吉林', '四平', '辽源', '通化', '白山', '松原', '白城', '延边'],
  '黑龙江': ['哈尔滨', '齐齐哈尔', '鸡西', '鹤岗', '双鸭山', '大庆', '伊春', '佳木斯', '七台河', '牡丹江', '黑河', '绥化', '大兴安岭'],
  '江苏': ['南京', '无锡', '徐州', '常州', '苏州', '南通', '连云港', '淮安', '盐城', '扬州', '镇江', '泰州', '宿迁'],
  '浙江': ['杭州', '宁波', '温州', '嘉兴', '湖州', '绍兴', '金华', '衢州', '舟山', '台州', '丽水'],
  '安徽': ['合肥', '芜湖', '蚌埠', '淮南', '马鞍山', '淮北', '铜陵', '安庆', '黄山', '滁州', '阜阳', '宿州', '六安', '亳州', '池州', '宣城'],
  '福建': ['福州', '厦门', '莆田', '三明', '泉州', '漳州', '南平', '龙岩', '宁德'],
  '江西': ['南昌', '景德镇', '萍乡', '九江', '新余', '鹰潭', '赣州', '吉安', '宜春', '抚州', '上饶'],
  '山东': ['济南', '青岛', '淄博', '枣庄', '东营', '烟台', '潍坊', '济宁', '泰安', '威海', '日照', '临沂', '德州', '聊城', '滨州', '菏泽'],
  '河南': ['郑州', '开封', '洛阳', '平顶山', '安阳', '鹤壁', '新乡', '焦作', '濮阳', '许昌', '漯河', '三门峡', '南阳', '商丘', '信阳', '周口', '驻马店'],
  '湖北': ['武汉', '黄石', '十堰', '宜昌', '襄阳', '鄂州', '荆门', '孝感', '荆州', '黄冈', '咸宁', '随州', '恩施'],
  '湖南': ['长沙', '株洲', '湘潭', '衡阳', '邵阳', '岳阳', '常德', '张家界', '益阳', '郴州', '永州', '怀化', '娄底', '湘西'],
  '广东': ['广州', '深圳', '珠海', '汕头', '佛山', '韶关', '湛江', '肇庆', '江门', '茂名', '惠州', '梅州', '汕尾', '河源', '阳江', '清远', '东莞', '中山', '潮州', '揭阳', '云浮'],
  '海南': ['海口', '三亚', '三沙', '儋州'],
  '四川': ['成都', '自贡', '攀枝花', '泸州', '德阳', '绵阳', '广元', '遂宁', '内江', '乐山', '南充', '眉山', '宜宾', '广安', '达州', '雅安', '巴中', '资阳', '阿坝', '甘孜', '凉山'],
  '贵州': ['贵阳', '六盘水', '遵义', '安顺', '毕节', '铜仁', '黔西南', '黔东南', '黔南'],
  '云南': ['昆明', '曲靖', '玉溪', '保山', '昭通', '丽江', '普洱', '临沧', '楚雄', '红河', '文山', '西双版纳', '大理', '德宏', '怒江', '迪庆'],
  '陕西': ['西安', '铜川', '宝鸡', '咸阳', '渭南', '延安', '汉中', '榆林', '安康', '商洛'],
  '甘肃': ['兰州', '嘉峪关', '金昌', '白银', '天水', '武威', '张掖', '平凉', '酒泉', '庆阳', '定西', '陇南', '临夏', '甘南'],
  '青海': ['西宁', '海东', '海北', '黄南', '海南', '果洛', '玉树', '海西'],
  '内蒙古': ['呼和浩特', '包头', '乌海', '赤峰', '通辽', '鄂尔多斯', '呼伦贝尔', '巴彦淖尔', '乌兰察布', '兴安', '锡林郭勒', '阿拉善'],
  '广西': ['南宁', '柳州', '桂林', '梧州', '北海', '防城港', '钦州', '贵港', '玉林', '百色', '贺州', '河池', '来宾', '崇左'],
  '西藏': ['拉萨', '日喀则', '昌都', '林芝', '山南', '那曲', '阿里'],
  '宁夏': ['银川', '石嘴山', '吴忠', '固原', '中卫'],
  '新疆': ['乌鲁木齐', '克拉玛依', '吐鲁番', '哈密', '昌吉', '博尔塔拉', '巴音郭楞', '阿克苏', '克孜勒苏', '喀什', '和田', '伊犁', '塔城', '阿勒泰'],
};

const unitTypeMap: Record<string, string> = {
  school: '学校',
  institution: '机构',
  individual: '个体'
};

interface Teacher {
  id: string;
  username: string;
  phone: string;
  region: string;
  unit_type: 'school' | 'institution' | 'individual';
  unit_name: string;
  audit_status: 'pending' | 'approved' | 'rejected';
  created_at: string;
  reject_reason?: string;
}

export default function TeacherAudit() {
  const [teachers, setTeachers] = useState<Teacher[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [auditModal, setAuditModal] = useState<{ open: boolean; teacher?: Teacher; action?: 'approved' | 'rejected' }>({ open: false });
  const [rejectReasonTemplates] = useState([
    '资质信息不完整',
    '单位名称无法核实',
    '联系方式无效',
    '其他原因'
  ]);
  const [selectedTemplate, setSelectedTemplate] = useState('');
  const [customReason, setCustomReason] = useState('');

  useEffect(() => {
    loadTeachers();
  }, []);

  const loadTeachers = async () => {
    setLoading(true);
    // 只查询待审核的教师
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('role', 'teacher')
      .eq('audit_status', 'pending')
      .order('created_at', { ascending: false });
    
    if (error) {
      console.error('加载教师列表失败:', error);
    } else {
      setTeachers(data as Teacher[]);
    }
    setLoading(false);
  };

  const filteredTeachers = teachers.filter(t => {
    return t.username.includes(searchQuery) || t.phone.includes(searchQuery);
  });

  const handleAudit = (teacher: Teacher, action: 'approved' | 'rejected') => {
    setAuditModal({ open: true, teacher, action });
    setSelectedTemplate('');
    setCustomReason('');
  };

  const confirmAudit = async () => {
    if (!auditModal.teacher || !auditModal.action) return;
    const { teacher, action } = auditModal;
    
    // 构建完整的拒绝理由
    const finalReason = action === 'rejected' 
      ? selectedTemplate + (customReason ? ` - ${customReason}` : '')
      : null;
    
    await supabase
      .from('profiles')
      .update({ audit_status: action, reject_reason: finalReason })
      .eq('id', teacher.id);

    // 发送站内信通知
    try {
      const session = await supabase.auth.getSession();
      await fetch(`${getSupabaseUrl()}/functions/v1/message-service`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${session.data.session?.access_token}`,
        },
        body: JSON.stringify({
          action: 'messages_send_notification',
          userIds: [teacher.id],
          templateCode: action === 'approved' ? 'teacher_approved' : 'teacher_rejected',
          variables: action === 'rejected' ? { reason: finalReason } : {}
        }),
      });
    } catch (error) {
      console.error('发送站内信失败:', error);
    }

    // 局部更新：从列表中移除已处理的教师
    setTeachers(prev => prev.filter(t => t.id !== teacher.id));
    setAuditModal({ open: false });
    setSelectedTemplate('');
    setCustomReason('');
  };

  const getRegionDisplay = (region: string) => {
    if (!region) return '-';
    const parts = region.split('-');
    if (parts.length === 2) {
      return `${parts[0]}-${parts[1]}`;
    }
    return region;
  };

  const getUnitTypeIcon = (unitType: string) => {
    switch (unitType) {
      case 'school': return <School className="w-4 h-4" />;
      case 'institution': return <Building2 className="w-4 h-4" />;
      case 'individual': return <UserCircle className="w-4 h-4" />;
      default: return null;
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-800">教师审核</h1>
        <p className="text-sm text-gray-500 mt-1">管理待审核的教师账号申请</p>
      </div>

      {/* 搜索栏 */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4">
        <div className="flex items-center gap-3">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" />
            <input
              type="text"
              placeholder="搜索姓名或手机号"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      </div>

      {/* 教师列表 */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        {filteredTeachers.length > 0 ? (
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">姓名</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">手机号</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">所属地区</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">单位性质</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">单位名称</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">注册时间</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">操作</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {filteredTeachers.map((teacher) => (
                <tr key={teacher.id} className="hover:bg-gray-50 transition-colors">
                  <td className="px-4 py-3 whitespace-nowrap">
                    <span className="text-sm font-medium text-blue-600">{teacher.username}</span>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    <div className="flex items-center gap-1.5 text-sm text-gray-600">
                      <Phone className="w-3.5 h-3.5" />
                      {teacher.phone?.includes('@') ? teacher.phone.split('@')[0] : teacher.phone}
                    </div>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    <div className="flex items-center gap-1.5 text-sm text-gray-600">
                      <MapPin className="w-3.5 h-3.5" />
                      {getRegionDisplay(teacher.region)}
                    </div>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    <div className="flex items-center gap-1.5 text-sm text-gray-600">
                      {getUnitTypeIcon(teacher.unit_type)}
                      {unitTypeMap[teacher.unit_type] || teacher.unit_type}
                    </div>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    <div className="flex items-center gap-1.5 text-sm text-gray-600">
                      <Building2 className="w-3.5 h-3.5" />
                      {teacher.unit_name || '-'}
                    </div>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    <div className="flex items-center gap-1.5 text-sm text-gray-500">
                      <Clock className="w-3.5 h-3.5" />
                      {formatDateTime(teacher.created_at)}
                    </div>
                  </td>
                  <td className="px-4 py-3 whitespace-nowrap">
                    <div className="flex items-center gap-2">
                      <button
                        onClick={() => handleAudit(teacher, 'approved')}
                        className="inline-flex items-center gap-1 px-3 py-1.5 bg-green-500 hover:bg-green-600 text-white text-xs font-medium rounded-lg transition-colors"
                      >
                        <CheckCircle className="w-3.5 h-3.5" />
                        通过
                      </button>
                      <button
                        onClick={() => handleAudit(teacher, 'rejected')}
                        className="inline-flex items-center gap-1 px-3 py-1.5 bg-red-500 hover:bg-red-600 text-white text-xs font-medium rounded-lg transition-colors"
                      >
                        <XCircle className="w-3.5 h-3.5" />
                        拒绝
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="p-12 text-center">
            <div className="w-16 h-16 rounded-full bg-blue-100 flex items-center justify-center mx-auto mb-4">
              <CheckCircle className="w-8 h-8 text-blue-600" />
            </div>
            <p className="text-gray-500 font-medium">暂无待审核的教师</p>
            <p className="text-sm text-gray-400 mt-1">所有教师申请已处理完毕</p>
          </div>
        )}
      </div>

      {/* 审核确认弹窗 */}
      <AnimatePresence>
        {auditModal.open && auditModal.teacher && (
          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <motion.div initial={{ scale: 0.9 }} animate={{ scale: 1 }} exit={{ scale: 0.9 }} className="bg-white rounded-xl p-6 w-[500px] max-h-[90vh] overflow-auto">
              <h3 className="text-lg font-bold text-gray-800 mb-4">{auditModal.action === 'approved' ? '通过审核' : '拒绝审核'}</h3>
              <div className="space-y-3 mb-4">
                <p className="text-sm text-gray-600"><span className="font-medium">姓名：</span>{auditModal.teacher.username}</p>
                <p className="text-sm text-gray-600"><span className="font-medium">手机号：</span>{auditModal.teacher.phone?.includes('@') ? auditModal.teacher.phone.split('@')[0] : auditModal.teacher.phone}</p>
                <p className="text-sm text-gray-600"><span className="font-medium">单位：</span>{auditModal.teacher.unit_name}</p>
                
                {/* 拒绝理由输入 */}
                {auditModal.action === 'rejected' && (
                  <div className="space-y-3 mt-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">选择拒绝原因模板</label>
                      <select
                        value={selectedTemplate}
                        onChange={(e) => setSelectedTemplate(e.target.value)}
                        className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500"
                      >
                        <option value="">请选择模板</option>
                        {rejectReasonTemplates.map((template, index) => (
                          <option key={index} value={template}>{template}</option>
                        ))}
                      </select>
                    </div>
                    
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">补充说明（可选）</label>
                      <textarea
                        value={customReason}
                        onChange={(e) => setCustomReason(e.target.value)}
                        placeholder="请输入补充说明..."
                        rows={3}
                        className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-red-500 resize-none"
                      />
                    </div>
                    
                    {(selectedTemplate || customReason) && (
                      <div className="bg-red-50 border border-red-200 rounded-lg p-3">
                        <p className="text-xs text-red-600 font-medium mb-1">预览：</p>
                        <p className="text-sm text-gray-700">
                          {selectedTemplate}{customReason ? ` - ${customReason}` : ''}
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="flex gap-3">
                <button 
                  onClick={() => {
                    setAuditModal({ open: false });
                    setSelectedTemplate('');
                    setCustomReason('');
                  }} 
                  className="flex-1 py-2 border border-gray-200 rounded-lg text-sm hover:bg-gray-50"
                >
                  取消
                </button>
                <button 
                  onClick={confirmAudit}
                  disabled={auditModal.action === 'rejected' && !selectedTemplate}
                  className={`flex-1 py-2 rounded-lg text-sm text-white transition-colors ${
                    auditModal.action === 'approved' 
                      ? 'bg-green-500 hover:bg-green-600' 
                      : (!selectedTemplate ? 'bg-red-300 cursor-not-allowed' : 'bg-red-500 hover:bg-red-600')
                  }`}
                >
                  确认{auditModal.action === 'approved' ? '通过' : '拒绝'}
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
